import React from 'react';
import { Typography, Button, Grid, Box, Stack } from '@mui/material';
import { useOidc } from '@axa-fr/react-oidc';
import gmslogogif from "../assets/Login Page - GMS-01-01.svg";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CopyrightOutlinedIcon from '@mui/icons-material/CopyrightOutlined';
import { useNavigate } from 'react-router-dom';
import "./Home.scss";

const Home: React.FC = () => {
  const { login, isAuthenticated } = useOidc();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/commondashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box className="home">
      <img
        src={gmslogogif}
        alt="Login Background"
        className="home__image"
      />
      {!isAuthenticated && (
        <Button
          className="home__login-btn"
          id="provider-web-home-button-login"
          variant="contained"
          size="large"
          onClick={() => login("/commondashboard")}
          endIcon={<ArrowForwardIcon />}
        >
          Login
        </Button>
      )}
      <Grid container>
        <Grid item xs={12}>
          <div className="home__footer">
            <Stack direction="row" spacing={1} className="home__footer-stack">
              <CopyrightOutlinedIcon />
              <Typography className="home__footer-text">
                Copyright 2026 GMS Inc - All Rights Reserved
              </Typography>
            </Stack>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;